import Model from "./abstract/Model";

export const VehicleStatusType = {
  AVAILABLE: 'AVAILABLE',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  BOOKING: 'BOOKING',
  BOOKED: 'BOOKED',
  DRIVING: 'DRIVING',
  VEHICLE_SIGNED_OFF: 'VEHICLE_SIGNED_OFF',
  RETURNED_TO_DEPOT: 'RETURNED_TO_DEPOT',
  PICKUP_ASSIGNMENT_SENT: 'PICKUP_ASSIGNMENT_SENT',
  MAINTENANCE_INTERNAL: 'MAINTENANCE_INTERNAL',
  MAINTENANCE_EXTERNAL: 'MAINTENANCE_EXTERNAL',
  DAMAGE: 'DAMAGE',
  CHECKUP: 'CHECKUP',
  PLAN_TRANSPORT: 'PLAN_TRANSPORT',
  PLANNED_TRANSPORT: 'PLANNED_TRANSPORT',
  REMOVED_FROM_FLEET: 'REMOVED_FROM_FLEET',
}

export default class VehicleStatus extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props, {
    });
  }

  get frontend_name() {
    // const type = VehicleStatusType.includes(this.type) ? this.type : ContractStatusType.TYPE_ARCHIVED;
    return i18n.constants['App\\Constants\\VehicleStatusType'][this.type].name;
  }

  isActive() {
    return this.type == VehicleStatusType.AVAILABLE;
  }
}
